import React from 'react'
import './Nav.css'
import {AiOutlineHome} from 'react-icons/ai'
import {BiUserCircle} from 'react-icons/bi'
import {BsBookHalf} from 'react-icons/bs'
import {RiServiceLine} from 'react-icons/ri'
import {IoCheckmarkDoneCircleOutline} from 'react-icons/io5'
import {TbMessage} from 'react-icons/tb'
import {useState} from 'react'

const Nav = () => {
 const [activeNav, setActiveNav]= useState('#')
  return (
    <nav>
      <a href="#" onClick={()=>setActiveNav('#')} className={activeNav==='#'?'active': ''}><AiOutlineHome/></a>
      <a href="#about" onClick={()=>setActiveNav('#about')} className={activeNav==='#about'?'active':''} ><BiUserCircle/></a>
      <a href="#experience"onClick={()=>setActiveNav('#experience')} className={activeNav==='#experience'?'active':''} ><BsBookHalf/></a>
      <a href="#services" onClick={()=>setActiveNav('#services')} className={activeNav==='#services'?'active':''} ><RiServiceLine/></a>
      <a href="#portfolio" onClick={()=>setActiveNav('#portfolio')} className={activeNav==='#portfolio'?'active':''} ><IoCheckmarkDoneCircleOutline/></a>
      <a href="#contact" onClick={()=>setActiveNav('#contact')} className={activeNav==='#contact'?'active':''} ><TbMessage/></a>
    </nav>
  )
}

export default Nav